export * from './VerticalSlide'
